// @flow

import React from 'react';
import classnames from 'classnames';
import { type Props } from '.';
import AnimatedDisplayElement from '../../animated-element';

class ShareholderCard extends React.Component<Props> {
  constructor() {
    super();
    this.toggleCard = this.toggleCard.bind(this);
    this.openMemberWorks = this.openMemberWorks.bind(this);
    this.state = {
      cardIsOpen: false,
    };
  }

  toggleCard() {
    const { cardIsOpen } = this.state;
    this.setState({
      cardIsOpen: !cardIsOpen,
    });
  }

  openMemberWorks() {
    const {
      addCurrentSearchParamsToHistory, updateSearchMeta, updateSearchParam, caeNumber, artistName,
      resetSearchPrams,
    } = this.props;
    addCurrentSearchParamsToHistory();
    resetSearchPrams();
    updateSearchMeta('artistName', artistName);
    updateSearchParam('caeNumber', caeNumber);
    updateSearchParam('workNumberType', 'ICE');
  }

  render() {
    const {
      roleName, artistName, performingShare, mechanicalShare, children, user,
    } = this.props;
    const { cardIsOpen } = this.state;
    return (
      <button className="shareholder-card" type="button" onClick={this.toggleCard}>
        <div className="d-flex flex-row justify-content-between">
          <h6>{roleName}</h6>
          <span
            className={classnames(
              'prs-icon shareholder-card--up prs-icon-chevron-down',
              { 'shareholder-card--up--open': cardIsOpen },
            )}
          />
        </div>
        <h4>{artistName}</h4>
        {user.profileType !== 'Licensee' && (
          <div className="d-flex flex-row shareholder-card--above-fold jst-share-percentage">
            <div className="flex-grow-1">
              <h5>Performing share</h5>
              <p className="m-0">
                {performingShare}
                {performingShare && '%'}
                {!performingShare && '--'}
              </p>
            </div>
            <div className="flex-grow-1">
              <h5>Mechanical share</h5>
              <p className="m-0">
                {mechanicalShare}
                {mechanicalShare && '%'}
                {!mechanicalShare && '--'}
              </p>
            </div>
          </div>
        )}
        <AnimatedDisplayElement showOn={cardIsOpen}>
          <div className="shareholder-card--below-fold">
            {children}
            <a onClick={this.openMemberWorks} href="#/memberworks" className="jst-view-works-button">
              <span className="prs-icon prs-icon-my-works" />
              <u>View works</u>
            </a>
          </div>
        </AnimatedDisplayElement>
      </button>
    );
  }
}

export default ShareholderCard;
